const localeUtils = require('utils/LanguageLocale');
const imageUtils = require('utils/Image');
const TYPES = require('reducers/productRecs').ACTION_TYPES;

function updateCarousel(recs) {
    let schema;
    const schemas = [];

    var reorg = function (scheme) {
        var prodRecs = [];
        const firstFivePIDs = [];

        (scheme.items || []).forEach(function (product, index) {
            product.skus = product.skus || [];

            // Oragnize data to how sephora components want it
            var candidate = product.skus[0];

            if (candidate) {
                candidate.certonaAudienceId = product.certona_audience_id;
                candidate.certonaExperienceId = product.certona_experience_id;
                candidate.isCertonaProduct = true;
                candidate.skuImages = { image: candidate.grid_images };
                candidate.badge = imageUtils.getImageBadgeFromUrl(candidate.grid_images);
                candidate.brandName = product.brand_name;
                candidate.productName = product.display_name;
                candidate.primaryProduct = product;
                candidate.productId = candidate.primary_product_id;
                candidate.skuId = candidate.sku_number;
                candidate.targetUrl = product.product_url;
                candidate.starRatings = product.rating;
                candidate.productReviewCount = product.reviews;
                candidate.isLimitedEdition = candidate.is_limited_edition || false;
                candidate.isNew = candidate.is_new || false;
                candidate.isSephoraExclusive = candidate.is_sephora_exclusive || false;
                candidate.isOnlineOnly = candidate.is_online_only || false;
                candidate.isAppExclusive = candidate.is_app_exclusive || false;
                candidate.isFirstAccess = candidate.is_first_access || false;
                candidate.isLimitedTimeOffer = candidate.is_limited_time_offer || false;
                candidate.listPrice = localeUtils.getFormattedPrice(candidate.list_price);
                candidate.salePrice = localeUtils.getFormattedPrice(candidate.sale_price);
                candidate.valuePrice = localeUtils.getFormattedPrice(candidate.value_price, true);
                candidate.wholeSalePrice = localeUtils.getFormattedPrice(candidate.wholesale_price, false, true, true);
                candidate.heroImageAltText = product.heroImageAltText || '';
                candidate.variationValue = candidate.variation_value || false;
                prodRecs = prodRecs.concat(candidate);

                if (!digitalData.page.attributes.initialPageLoadDidOccur) {
                    const recsForAnalytics = digitalData.page.attributes.externalRecommendations || {};

                    if (!recsForAnalytics.vendor) {
                        digitalData.page.attributes.externalRecommendations = {
                            vendor: 'certona',
                            audienceId: product.certona_audience_id,
                            experienceId: product.certona_experience_id
                        };
                    }

                    if (!recsForAnalytics.firstFivePIDs && index <= 5) {
                        firstFivePIDs.push(product.id);

                        if (index === 4 || index === scheme.items.length - 1) {
                            digitalData.page.attributes.externalRecommendations.firstFivePIDs = firstFivePIDs.join('|');
                        }
                    }
                }
            }

            delete product.skus;
        });

        return prodRecs;
    };

    while ((schema = recs.resonance.schemes.shift())) {
        schemas.push({
            isDisplay: schema.display === 'yes',
            recommendTitle: schema.explanation,
            name: schema.scheme,
            data: reorg(schema)
        });
    }

    return {
        type: TYPES.UPDATE_CAROUSEL,
        recs: schemas
    };
}

function getProductFinderData(items) {
    const data = updateCarousel(items);

    return {
        type: TYPES.PRODUCT_FINDER_DATA,
        productFinderData: data.recs[0]
    };
}

function isQuizSubmitted(value) {
    return {
        type: TYPES.IS_QUIZ_SUBMITTED,
        isQuizSubmitted: value
    };
}

function setQuizCacheResults(value) {
    return {
        type: TYPES.SET_QUIZ_CACHE_RESULTS,
        cache: value
    };
}

function updateCertonaObject(value) {
    return {
        type: TYPES.UPDATE_CERTONA_OBJECT,
        certonaObject: value
    };
}

function resetCertona() {
    return {
        type: TYPES.RESET_CERTONA
    };
}

function updateCertonaFailed() {
    return {
        type: TYPES.UPDATE_CERTONA_FAILED
    };
}

function resetCertonaSimilarProducts() {
    return {
        type: TYPES.RESET_CERTONA_SIMILAR_PRODUCTS
    };
}

module.exports = {
    TYPES,
    updateCarousel,
    updateProductFinderData: getProductFinderData,
    isQuizSubmitted,
    updateCertonaObject,
    setQuizCacheResults,
    updateCertonaFailed,
    resetCertona,
    resetCertonaSimilarProducts
};
